import { MedalIcon } from '@/components/icons'
import React from 'react'

interface WinnerCardProps {
  rank: number
  name: string
}

const WinnerCard: React.FC<WinnerCardProps> = ({ name, rank }) => {
  return (
    <div className="p-2 border bg-slate-100">
      <div className="flex items-center gap-x-2">
        <div className="flex items-center justify-center\">
          {rank <= 3 ? (
            <MedalIcon
              className={`w-6 h-6 ${rank === 1 ? 'text-[#fd9a28]' : rank === 2 ? 'text-[#e8e8ed]' : 'text-[#e86769]'}`}
            />
          ) : null}
        </div>
        <div className="flex w-[231px] flex-col gap-y-1">
          <p className="text-xl text-gray-500">
            {rank === 1 ? 'FIRST' : rank === 2 ? 'SECOND' : rank === 3 ? 'THIRD' : ''}
          </p>
          <p className="text-navy-900 text-sm font-semibold truncate">{name}</p>
        </div>
      </div>
    </div>
  )
}

export default WinnerCard
